document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mt-blog-list').forEach(function (container) {
    var track = container.querySelector('.mt-blog-list__track');
    var progressContainer = container.querySelector('.mt-blog-list__progress');
    var progressBar = container.querySelector('.mt-blog-list__progress-bar');
    var prevBtn = container.querySelector('.mt-blog-list__arrow--prev');
    var nextBtn = container.querySelector('.mt-blog-list__arrow--next');
    
    if (!track) return;

    // 更新进度条和按钮状态
    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      
      // 如果有进度条，更新进度条
      if (progressBar && progressContainer) {
        if (maxScroll <= 0) {
          progressBar.style.width = '100%';
          progressBar.style.left = '0';
        } else {
          var percent = track.scrollLeft / maxScroll;
          var thumbWidth = (track.clientWidth / track.scrollWidth) * 100;
          progressBar.style.width = thumbWidth + '%';
          progressBar.style.left = percent * (100 - thumbWidth) + '%';
        }
      }
      
      // 更新按钮状态
      if (prevBtn && nextBtn) {
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
      }
    }

    // 进度条点击跳转（如果有的话）
    if (progressContainer) {
      progressContainer.addEventListener('click', function(e) {
        var rect = progressContainer.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var progressWidth = rect.width;
        var percent = clickX / progressWidth;
        
        var maxScroll = track.scrollWidth - track.clientWidth;
        var targetScrollLeft = percent * maxScroll;
        
        track.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth'
        });
      });
    }

    // 获取当前应该使用的每行数量（根据屏幕大小）
    function getItemsPerRow() {
      var isMobile = window.innerWidth <= 749;
      var attrName = isMobile ? 'data-mobile-items-per-row' : 'data-items-per-row';
      return parseInt(container.getAttribute(attrName)) || (isMobile ? 1 : 2);
    }

    // 上一个按钮
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var items = track.querySelectorAll('.mt-blog-list__item');
        if (items.length > 0) {
          var itemsPerRow = getItemsPerRow();
          var itemWidth = items[0].offsetWidth;
          var gap = 24;
          var scrollAmount = itemWidth + gap;
          track.scrollBy({
            left: -scrollAmount * itemsPerRow, // 一次滚动一整行
            behavior: 'smooth'
          });
        }
      });
    }

    // 下一个按钮
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var items = track.querySelectorAll('.mt-blog-list__item');
        if (items.length > 0) {
          var itemsPerRow = getItemsPerRow();
          var itemWidth = items[0].offsetWidth;
          var gap = 24;
          var scrollAmount = itemWidth + gap;
          track.scrollBy({
            left: scrollAmount * itemsPerRow, // 一次滚动一整行
            behavior: 'smooth'
          });
        }
      });
    }

    // 监听滚动事件
    track.addEventListener('scroll', updateProgress);
    window.addEventListener('resize', updateProgress);
    
    // 初始化
    setTimeout(updateProgress, 100);
  });
});

